var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99737 14.5852C9.76811 14.5852 9.58053 14.7728 9.58303 15.002C9.58303 15.2313 9.77061 15.4189 9.99987 15.4189C10.2291 15.4189 10.4167 15.2313 10.4167 15.002C10.4167 14.7728 10.2291 14.5852 9.99737 14.5852",
    stroke: "#4D5E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99737 9.58313C9.76811 9.58313 9.58053 9.77071 9.58303 9.99997C9.58303 10.2292 9.77061 10.4168 9.99987 10.4168C10.2291 10.4168 10.4167 10.2292 10.4167 9.99997C10.4167 9.77071 10.2291 9.58313 9.99737 9.58313",
    stroke: "#4D5E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99737 4.58105C9.76811 4.58105 9.58053 4.76863 9.58303 4.99789C9.58303 5.22716 9.77061 5.41474 9.99987 5.41474C10.2291 5.41474 10.4167 5.22716 10.4167 4.99789C10.4167 4.76863 10.2291 4.58105 9.99737 4.58105",
    stroke: "#4D5E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ea658b500d08abdb0228b295f77e05b6.svg";
export { ForwardRef as ReactComponent };